/* eslint-disable */
import { colors } from '../../helper/constant/colors';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import meya_logo from '../../assets/images/logo_meya.png';
import { THAI_PROVINCES } from '../../helper/constant';
import { DatePicker, TimePicker, ConfigProvider } from 'antd';
import thTH from 'antd/locale/th_TH';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.locale('th');
import {
  formatSalary,
  formatShortDate,
  getShopContext,
  JOB_CATEGORY_NAME_TO_ID,
  detectProvinceFromText,
  inferJobCategoryFromText,
  resolveJobCategory,
  fetchAllPagedItems,
  resolveMapCoords,
  markJobImagesCleared,
  unmarkJobImagesCleared,
  isJobImagesCleared,
  resolveJobPosterImages,
  getProvinceCoords,
  spreadCoordsById,
  getFriendlyErrorMsg,
} from './jobUtils';
import './EmployerJobDashboard.css';

function EmployerJobDashboard({ permitdata, app_hostname }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isShopMember = (() => {
    if (
      permitdata &&
      permitdata.role !== 'guest' &&
      permitdata.token &&
      permitdata.token !== '-' &&
      permitdata.shop_id &&
      permitdata.shop_id !== '-'
    ) {
      return true;
    }
    try {
      const stored = sessionStorage.getItem('meya-token4');
      if (stored && stored !== 'undefined') {
        const parsed = JSON.parse(stored);
        if (
          parsed &&
          parsed.role !== 'guest' &&
          parsed.token &&
          parsed.token !== '-' &&
          parsed.shop_id &&
          parsed.shop_id !== '-'
        ) {
          return true;
        }
      }
    } catch (e) {}
    return false;
  })();

  const getTabFromUrl = () => {
    try {
      const sp = new URLSearchParams(location.search);
      const tab = sp.get('tab');
      if (tab && ['manage_jobs', 'applicants', 'post_job', 'company_profile'].includes(tab)) {
        return tab;
      }
    } catch (e) {}
    return 'manage_jobs';
  };

  const [activeTab, setActiveTab] = useState(getTabFromUrl); // 'manage_jobs', 'applicants', 'post_job', 'company_profile'

  useEffect(() => {
    try {
      const sp = new URLSearchParams(location.search);
      const tab = sp.get('tab');
      if (tab && ['manage_jobs', 'applicants', 'post_job', 'company_profile'].includes(tab)) {
        setActiveTab(tab);
      }
    } catch (e) {}
  }, [location.search]);

  const [jobsList, setJobsList] = useState([]);
  const [applicantsList, setApplicantsList] = useState([]);
  const [applicantFilter, setApplicantFilter] = useState('all'); // 'all' | 'interview'
  const [applicantJobFilter, setApplicantJobFilter] = useState(''); // job id or ''
  const [applicantSearch, setApplicantSearch] = useState('');
  const [toastMsg, setToastMsg] = useState('');
  const [selectedApplicant, setSelectedApplicant] = useState(null);
  const [interviewDate, setInterviewDate] = useState(() => dayjs());
  const [interviewTime, setInterviewTime] = useState(() => dayjs('10:30', 'HH:mm'));
  const [interviewChannel, setInterviewChannel] = useState('onsite');
  const [interviewNotes, setInterviewNotes] = useState('');
  const [applicantImgErrors, setApplicantImgErrors] = useState({});
  const [editingJobId, setEditingJobId] = useState(null);
  const [jobListSearch, setJobListSearch] = useState('');
  const [dashboardLoading, setDashboardLoading] = useState(true);
  const editJobHandledRef = useRef(null);
  const dashboardLoadedRef = useRef(false);

  // Centralized Shop Logo State & Ref
  const [currentShopLogo, setCurrentShopLogo] = useState(() => {
    if (permitdata?.shop_logo && permitdata.shop_logo !== '-') return permitdata.shop_logo;
    try {
      const stored = sessionStorage.getItem('meya-token4');
      if (stored && stored !== 'undefined') {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.shop_logo && parsed.shop_logo !== '-') return parsed.shop_logo;
      }
    } catch (e) {}
    return '';
  });
  const [isUploadingShopLogo, setIsUploadingShopLogo] = useState(false);
  const shopLogoInputRef = useRef(null);

  const getLogoSrc = (logoUrl) => {
    if (!logoUrl) return meya_logo;
    if (
      logoUrl.startsWith('http://') ||
      logoUrl.startsWith('https://') ||
      logoUrl.startsWith('data:')
    )
      return logoUrl;
    return (app_hostname || '') + logoUrl;
  };

  const handleApplicantImgError = (id) => {
    setApplicantImgErrors((prev) => ({ ...prev, [id]: true }));
  };

  const fetchDashboardData = async () => {
    setDashboardLoading(true);
    try {
      const { shopId: currentShopId } = getShopContext(permitdata);
      const currentEmployerId = currentShopId || permitdata?.user_id || '';
      const queryUrl = (app_hostname || '') + '/api/market/jobs/query';
      const appsUrl = (app_hostname || '') + '/api/market/jobs/applicant_list';

      const [jobRows, appRows, logoRes] = await Promise.all([
        fetchAllPagedItems({
          pageSize: 50,
          maxPages: 40,
          request: (payload) =>
            axios.post(queryUrl, {
              ...payload,
              shop_id: currentShopId,
              employer_id: currentEmployerId,
            }),
        }),
        fetchAllPagedItems({
          pageSize: 100,
          maxPages: 40,
          request: (payload) =>
            axios.post(appsUrl, {
              ...payload,
              job_id: '0',
              status: 'all',
              shop_id: currentShopId,
              employer_id: currentEmployerId,
            }),
        }).catch(async () => {
          // Fallback if applicant_list ignores paging and errors on page>1
          const res = await axios.post(appsUrl, {
            job_id: '0',
            status: 'all',
            shop_id: currentShopId,
            employer_id: currentEmployerId,
            page: 1,
            page_size: 500,
          });
          if (res?.data?.status === 'Success' && res.data.data) {
            return res.data.data.items || [];
          }
          return [];
        }),
        currentShopId && currentShopId !== '-'
          ? axios
              .post((app_hostname || '') + '/api/market/jobs/shop/get_logo', {
                shop_id: currentShopId,
              })
              .catch(() => null)
          : Promise.resolve(null),
      ]);

      if (
        logoRes &&
        logoRes.data &&
        logoRes.data.status === 'Success' &&
        logoRes.data.data?.shop_logo
      ) {
        const fetchedLogo = logoRes.data.data.shop_logo;
        setCurrentShopLogo(fetchedLogo);
        try {
          const stored = sessionStorage.getItem('meya-token4');
          if (stored && stored !== 'undefined') {
            const parsed = JSON.parse(stored);
            parsed.shop_logo = fetchedLogo;
            sessionStorage.setItem('meya-token4', JSON.stringify(parsed));
          }
        } catch (e) {}
      }

      const applicantCountMap = {};
      const apps = Array.isArray(appRows) ? appRows : [];
      apps.forEach((a) => {
        const jId = String(a.job_id || a.jobId || '');
        if (jId) {
          applicantCountMap[jId] = (applicantCountMap[jId] || 0) + 1;
        }
      });
      setApplicantsList(
        apps.map((a) => ({
          id: a.application_id || a.id,
          jobId: String(a.job_id || a.jobId || ''),
          name: a.applicant_name,
          appliedJob: a.job_title,
          category: 'การแพทย์/สาธารณสุข',
          experience: 'พร้อมเริ่มงาน',
          appliedDate: formatShortDate(a.created_at),
          expectedSalary: a.expected_salary
            ? a.expected_salary.toLocaleString() + ' บาท'
            : 'ตามตกลง',
          status: a.status || 'pending',
          avatar: a.avatar && String(a.avatar).trim() !== '' ? a.avatar : '',
          email: a.applicant_email,
          phone: a.applicant_phone,
          resumeUrl: a.resume_url,
          seekerId: a.seeker_id || a.seekerId || a.user_id || '',
        })),
      );

      setJobsList(
        (jobRows || []).map((j) => {
          const jId = String(j.job_id || j.id);
          const coords = resolveMapCoords({
            id: jId,
            lat: j.lat,
            lng: j.lng,
            province: j.province,
            address: j.address,
            title: j.title,
            company: j.company_name,
            district: j.district,
          });
          return {
            id: jId,
            title: j.title,
            category: resolveJobCategory(j.title, j.category_name),
            location: coords.province || j.province,
            salary: formatSalary(j.salary_min, j.salary_max, j.salary_text, j.salary_negotiable),
            type: j.job_type,
            postedDate: formatShortDate(j.created_at),
            expiryDate: 'อีก 30 วัน',
            status: j.status,
            applicantsCount: applicantCountMap[jId] || 0,
            viewsCount: j.view_count || 1,
            _raw: j,
          };
        }),
      );
    } catch (e) {
      // ignore
    } finally {
      dashboardLoadedRef.current = true;
      setDashboardLoading(false);
    }
  };

  useEffect(() => {
    if (isShopMember) {
      fetchDashboardData();
    }
  }, [permitdata?.shop_id, isShopMember]);

  // New Job Post Form State
  const [newJobForm, setNewJobForm] = useState({
    title: '',
    category: 'เภสัชกร',
    type: 'Full Time',
    location: '',
    province: 'กรุงเทพมหานคร',
    district: '',
    companyLogo: '',
    posterImage: '',
    galleryImages: [],
    salaryMin: '35,000',
    salaryMax: '45,000',
    experience: '1-2 ปี',
    education: 'ปริญญาตรี',
    website: '',
    description: '',
    qualifications: '',
    benefits: ['ประกันสังคม', 'โบนัสประจำปี', 'ค่าใบประกอบวิชาชีพ', 'ประกันสุขภาพกลุ่ม'],
  });

  const [geoCoords, setGeoCoords] = useState({
    lat: null,
    lng: null,
    status: 'idle',
    displayName: '',
  });
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isUploadingPoster, setIsUploadingPoster] = useState(false);

  // Auto-fill address from shop profile (permitdata)
  useEffect(() => {
    if (permitdata && permitdata.shop_id && permitdata.shop_id !== '-') {
      const addressParts = [
        permitdata.shop_address,
        permitdata.shop_subdistrict,
        permitdata.shop_district,
        permitdata.shop_province,
        permitdata.shop_postcode,
      ].filter((part) => part && part !== '-' && String(part).trim() !== '');

      const fullAddress = addressParts.join(' ');
      const prov =
        permitdata.shop_province && permitdata.shop_province !== '-'
          ? permitdata.shop_province
          : 'กรุงเทพมหานคร';
      const dist =
        permitdata.shop_district && permitdata.shop_district !== '-'
          ? permitdata.shop_district
          : '';

      setNewJobForm((prev) => {
        if (!prev.location || prev.location === 'กรุงเทพมหานคร') {
          return {
            ...prev,
            location: fullAddress || prov,
            province: prov,
            district: dist,
          };
        }
        return prev;
      });
    }
  }, [permitdata]);

  // Geocode address to lat/lng using Nominatim
  const resolveCoordinates = async (addressQuery) => {
    if (!addressQuery || !addressQuery.trim()) return null;
    setIsGeocoding(true);
    try {
      const query = addressQuery.trim();
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&countrycodes=th&limit=1`;
      const res = await axios.get(url, {
        headers: { 'User-Agent': 'MeyaApp/1.0 (contact@meya.app)' },
        timeout: 4000,
      });
      if (res.data && res.data.length > 0) {
        const latVal = parseFloat(res.data[0].lat);
        const lngVal = parseFloat(res.data[0].lon);
        if (!isNaN(latVal) && !isNaN(lngVal)) {
          const result = {
            lat: latVal,
            lng: lngVal,
            status: 'found',
            displayName: res.data[0].display_name,
          };
          setGeoCoords(result);
          return result;
        }
      }
      // Fallback by removing specific street numbers or using district/province
      const fallbackParts = query.split(' ').filter(Boolean);
      if (fallbackParts.length > 1) {
        const broaderQuery = fallbackParts.slice(1).join(' ');
        const broaderUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(broaderQuery)}&countrycodes=th&limit=1`;
        const broaderRes = await axios.get(broaderUrl, {
          headers: { 'User-Agent': 'MeyaApp/1.0 (contact@meya.app)' },
          timeout: 3000,
        });
        if (broaderRes.data && broaderRes.data.length > 0) {
          const latVal = parseFloat(broaderRes.data[0].lat);
          const lngVal = parseFloat(broaderRes.data[0].lon);
          if (!isNaN(latVal) && !isNaN(lngVal)) {
            const result = {
              lat: latVal,
              lng: lngVal,
              status: 'found',
              displayName: broaderRes.data[0].display_name,
            };
            setGeoCoords(result);
            return result;
          }
        }
      }
      setGeoCoords((prev) => ({ ...prev, status: 'not_found' }));
      return null;
    } catch (e) {
      setGeoCoords((prev) => ({ ...prev, status: 'error' }));
      return null;
    } finally {
      setIsGeocoding(false);
    }
  };

  // Debounced geocoding whenever location text changes
  useEffect(() => {
    if (newJobForm.location && newJobForm.location.trim().length > 3) {
      const timer = setTimeout(() => {
        resolveCoordinates(newJobForm.location);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [newJobForm.location]);
  // Auto-sync master shop logo into new job form if empty
  useEffect(() => {
    if (currentShopLogo) {
      setNewJobForm((prev) => {
        if (!prev.companyLogo) {
          return { ...prev, companyLogo: currentShopLogo };
        }
        return prev;
      });
    }
  }, [currentShopLogo]);

  // Handler for uploading / updating master shop logo
  const handleShopLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      triggerToast('ขนาดรูปภาพต้องไม่เกิน 5MB');
      return;
    }

    const currentShopId =
      permitdata?.shop_id ||
      (() => {
        try {
          const stored = sessionStorage.getItem('meya-token4');
          if (stored && stored !== 'undefined') {
            return JSON.parse(stored)?.shop_id;
          }
        } catch (e) {}
        return '';
      })();

    if (!currentShopId || currentShopId === '-') {
      triggerToast('ไม่พบข้อมูลรหัสร้านค้า (shop_id)');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('shop_id', currentShopId);

    setIsUploadingShopLogo(true);
    try {
      const res = await axios.post(
        (app_hostname || '') + '/api/market/jobs/shop/update_logo',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (res.data && res.data.status === 'Success') {
        const uploadedUrl = res.data.data?.shop_logo || res.data.shop_logo;
        setCurrentShopLogo(uploadedUrl);
        setNewJobForm((prev) => ({ ...prev, companyLogo: uploadedUrl }));

        // Update sessionStorage
        try {
          const stored = sessionStorage.getItem('meya-token4');
          if (stored && stored !== 'undefined') {
            const parsed = JSON.parse(stored);
            parsed.shop_logo = uploadedUrl;
            sessionStorage.setItem('meya-token4', JSON.stringify(parsed));
          }
        } catch (e) {}

        triggerToast('อัปเดตโลโก้ร้านค้าเรียบร้อยแล้ว!');
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'เกิดข้อผิดพลาดในการอัปเดตโลโก้'));
      }
    } catch (err) {
      console.error('Error uploading shop logo:', err);
      triggerToast('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
    } finally {
      setIsUploadingShopLogo(false);
      if (e.target) e.target.value = '';
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'logo');
    setIsUploadingImage(true);
    try {
      const res = await axios.post(
        (app_hostname || '') + '/api/market/jobs/upload_image',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      if (res.data && res.data.status === 'Success' && res.data.data?.file_url) {
        setNewJobForm((prev) => ({ ...prev, companyLogo: res.data.data.file_url }));
        triggerToast('อัปโหลดโลโก้บริษัทสำเร็จ!');
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'อัปโหลดรูปไม่สำเร็จ'));
      }
    } catch (err) {
      triggerToast('เกิดข้อผิดพลาดในการอัปโหลดโลโก้');
    } finally {
      setIsUploadingImage(false);
    }
  };

  const handleAddGalleryImage = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setIsUploadingPoster(true);
    try {
      const uploadedUrls = [];
      for (const file of files) {
        if (file.size > 5 * 1024 * 1024) continue;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', 'poster');
        const res = await axios.post(
          (app_hostname || '') + '/api/market/jobs/upload_image',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          },
        );
        if (res.data && res.data.status === 'Success' && res.data.data?.file_url) {
          uploadedUrls.push(res.data.data.file_url);
        }
      }
      if (uploadedUrls.length > 0) {
        if (editingJobId) unmarkJobImagesCleared(editingJobId);
        setNewJobForm((prev) => {
          const currentList =
            Array.isArray(prev.galleryImages) && prev.galleryImages.length > 0
              ? prev.galleryImages
              : prev.posterImage && !isJobImagesCleared(editingJobId)
                ? [prev.posterImage]
                : [];
          const updated = [...currentList, ...uploadedUrls].slice(0, 6);
          return {
            ...prev,
            galleryImages: updated,
            posterImage: updated[0] || '',
          };
        });
        triggerToast(`อัปโหลดรูปภาพสำเร็จ ${uploadedUrls.length} รูป!`);
      }
    } catch (err) {
      triggerToast('เกิดข้อผิดพลาดในการอัปโหลดรูปภาพ');
    } finally {
      setIsUploadingPoster(false);
      if (e.target) e.target.value = '';
    }
  };

  const handleRemoveGalleryImage = (indexToRemove) => {
    setNewJobForm((prev) => {
      // Empty gallery array means intentional clear — do not revive posterImage
      const currentList = Array.isArray(prev.galleryImages)
        ? [...prev.galleryImages]
        : prev.posterImage
          ? [prev.posterImage]
          : [];
      const updated = currentList.filter((_, idx) => idx !== indexToRemove);
      return {
        ...prev,
        galleryImages: updated,
        posterImage: updated[0] || '',
      };
    });
    triggerToast('ลบรูปออกจากรายการแล้ว — กดบันทึกเพื่อยืนยัน');
  };

  const triggerToast = (msg) => {
    setToastMsg(msg);
    setTimeout(() => setToastMsg(''), 3500);
  };

  const goToTab = (tab, options = {}) => {
    setActiveTab(tab);
    if (tab === 'applicants') {
      setApplicantFilter(options.applicantFilter || 'all');
      setApplicantJobFilter(options.jobId || '');
      if (options.search !== undefined) setApplicantSearch(options.search);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const filteredApplicants = applicantsList.filter((a) => {
    if (applicantFilter !== 'all' && a.status !== applicantFilter) return false;
    if (applicantFilter === 'all' && a.status === 'rejected') return false;
    if (applicantJobFilter) {
      const matchId = String(a.jobId || '') === String(applicantJobFilter);
      const job = jobsList.find((j) => String(j.id) === String(applicantJobFilter));
      const matchTitle = job ? String(a.appliedJob || '').includes(job.title || '') : false;
      if (!matchId && !matchTitle) return false;
    }
    const q = applicantSearch.trim().toLowerCase();
    if (!q) return true;
    return (
      String(a.name || '')
        .toLowerCase()
        .includes(q) ||
      String(a.appliedJob || '')
        .toLowerCase()
        .includes(q) ||
      String(a.phone || '')
        .toLowerCase()
        .includes(q) ||
      String(a.email || '')
        .toLowerCase()
        .includes(q)
    );
  });

  const handleToggleJobStatus = async (id) => {
    const target = jobsList.find((j) => j.id === id);
    if (!target) return;
    const nextStatus = target.status === 'active' ? 'closed' : 'active';
    try {
      const res = await axios.post((app_hostname || '') + '/api/market/jobs/update_post_status', {
        job_id: id,
        status: nextStatus,
      });
      if (res.data && res.data.status === 'Success') {
        setJobsList((prev) =>
          prev.map((job) => (job.id === id ? { ...job, status: nextStatus } : job)),
        );
        triggerToast(
          nextStatus === 'active' ? 'เปิดรับสมัครตำแหน่งนี้แล้ว' : 'ปิดรับสมัครตำแหน่งนี้ชั่วคราว',
        );
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'ไม่สามารถอัปเดตสถานะได้'));
      }
    } catch (err) {
      triggerToast('ไม่สามารถอัปเดตสถานะได้');
    }
  };

  const handleDeleteJob = async (id) => {
    if (
      !window.confirm(
        'คุณต้องการลบประกาศรับสมัครงานนี้ใช่หรือไม่?\n(เมื่อลบแล้วประกาศนี้จะไม่แสดงในระบบอีก)',
      )
    ) {
      return;
    }
    try {
      const res = await axios.post((app_hostname || '') + '/api/market/jobs/update_post_status', {
        job_id: id,
        status: 'deleted',
      });
      if (res.data && res.data.status === 'Success') {
        setJobsList((prev) => prev.filter((j) => j.id !== id));
        triggerToast('ลบประกาศรับสมัครงานเรียบร้อยแล้ว');
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'ไม่สามารถลบประกาศงานได้'));
      }
    } catch (err) {
      console.error('[DeleteJob] Error:', err);
      triggerToast('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
    }
  };

  const handleStartEditJob = (job) => {
    const raw = job._raw || {};
    setEditingJobId(job.id);

    let gImages = [];
    if (isJobImagesCleared(job.id)) {
      gImages = [];
    } else {
      const resolved = resolveJobPosterImages({
        jobId: job.id,
        posterImage: raw.poster_image,
        galleryImages: raw.gallery_images,
        logoUrl: '',
        preferLogoWhenEmpty: false,
      });
      gImages = resolved.hasCustomPoster ? resolved.images : [];
    }

    let benList = ['ประกันสังคม', 'โบนัสประจำปี'];
    if (raw.benefits) {
      benList = raw.benefits
        .split(',')
        .map((b) => b.trim())
        .filter(Boolean);
    }

    const detectedProv =
      detectProvinceFromText(raw.address || '') ||
      detectProvinceFromText(raw.title || '') ||
      detectProvinceFromText(job.title || '');
    const finalProv =
      detectedProv && detectedProv !== 'กรุงเทพมหานคร'
        ? detectedProv
        : raw.province || detectedProv || 'กรุงเทพมหานคร';

    setNewJobForm({
      title: raw.title || job.title || '',
      category: raw.category_name || job.category || 'เภสัชกร',
      type: raw.job_type || job.type || 'Full Time',
      location: raw.address || job.location || raw.province || '',
      province: finalProv,
      district: raw.district || '',
      companyLogo: raw.company_logo || currentShopLogo || '',
      posterImage: gImages[0] || '',
      galleryImages: gImages,
      salaryMin: raw.salary_min ? raw.salary_min.toLocaleString() : '35,000',
      salaryMax: raw.salary_max ? raw.salary_max.toLocaleString() : '45,000',
      experience: raw.experience_required || '1-2 ปี',
      education: raw.education_level || 'ปริญญาตรี',
      website: raw.company_website || '',
      description: raw.description || '',
      qualifications: raw.requirements || '',
      benefits: benList,
    });

    const rawLat = Number(raw.lat);
    const rawLng = Number(raw.lng);
    const isBkkDefaultCoord =
      Number.isFinite(rawLat) &&
      Number.isFinite(rawLng) &&
      Math.abs(rawLat - 13.7563) < 0.00015 &&
      Math.abs(rawLng - 100.5018) < 0.00015;
    const hasValidCoords =
      Number.isFinite(rawLat) && Number.isFinite(rawLng) && !(rawLat === 0 && rawLng === 0);

    if (hasValidCoords && (!isBkkDefaultCoord || finalProv === 'กรุงเทพมหานคร')) {
      setGeoCoords({
        lat: rawLat,
        lng: rawLng,
        status: 'found',
        displayName: raw.address || finalProv,
      });
    } else {
      const provCoords = getProvinceCoords(finalProv);
      if (provCoords) {
        setGeoCoords({
          lat: provCoords.lat,
          lng: provCoords.lng,
          status: 'found',
          displayName: finalProv,
        });
      } else {
        setGeoCoords({ lat: null, lng: null, status: 'idle', displayName: '' });
      }
    }

    setActiveTab('post_job');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    try {
      const sp = new URLSearchParams(location.search);
      const editId = sp.get('edit');
      if (!editId || dashboardLoading || !dashboardLoadedRef.current) return;
      if (
        editJobHandledRef.current === String(editId) ||
        editJobHandledRef.current === `missing:${editId}`
      ) {
        return;
      }
      if (!jobsList.length) {
        editJobHandledRef.current = `missing:${editId}`;
        triggerToast('ไม่พบประกาศงานที่ต้องการแก้ไขในรายการร้านค้านี้');
        return;
      }
      const target = jobsList.find((j) => String(j.id) === String(editId));
      if (!target) {
        editJobHandledRef.current = `missing:${editId}`;
        triggerToast('ไม่พบประกาศงานรหัส ' + editId);
        return;
      }
      editJobHandledRef.current = String(editId);
      handleStartEditJob(target);
    } catch (e) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, jobsList, dashboardLoading]);

  const filteredJobsList = jobsList.filter((job) => {
    const q = jobListSearch.trim().toLowerCase();
    if (!q) return true;
    return (
      String(job.title || '')
        .toLowerCase()
        .includes(q) ||
      String(job.location || '')
        .toLowerCase()
        .includes(q) ||
      String(job.category || '')
        .toLowerCase()
        .includes(q) ||
      String(job.type || '')
        .toLowerCase()
        .includes(q) ||
      String(job.id || '')
        .toLowerCase()
        .includes(q) ||
      String(job.salary || '')
        .toLowerCase()
        .includes(q)
    );
  });

  const handleCancelEdit = () => {
    setEditingJobId(null);
    setActiveTab('manage_jobs');
  };

  const startNewJobPost = () => {
    setEditingJobId(null);
    const defaultProv =
      permitdata?.shop_province && permitdata.shop_province !== '-'
        ? permitdata.shop_province
        : 'กรุงเทพมหานคร';
    const defaultDist =
      permitdata?.shop_district && permitdata.shop_district !== '-'
        ? permitdata.shop_district
        : '';
    setNewJobForm({
      title: '',
      category: 'เภสัชกร',
      type: 'Full Time',
      location: '',
      province: defaultProv,
      district: defaultDist,
      companyLogo: currentShopLogo || '',
      posterImage: '',
      galleryImages: [],
      salaryMin: '35,000',
      salaryMax: '45,000',
      description: '',
      qualifications: '',
      benefits: ['ประกันสังคม', 'โบนัสประจำปี'],
    });
    const provCoords = getProvinceCoords(defaultProv);
    if (provCoords) {
      setGeoCoords({
        lat: provCoords.lat,
        lng: provCoords.lng,
        status: 'found',
        displayName: defaultProv,
      });
    } else {
      setGeoCoords({ lat: null, lng: null, status: 'idle', displayName: '' });
    }
    setActiveTab('post_job');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleUpdateApplicantStatus = async (applicantId, newStatus, notes = '') => {
    try {
      const res = await axios.post((app_hostname || '') + '/api/market/jobs/applicant_status', {
        application_id: applicantId,
        status: newStatus,
        notes,
      });
      if (res.data && res.data.status === 'Success') {
        setApplicantsList((prev) =>
          prev.map((a) => {
            if (a.id === applicantId) {
              return { ...a, status: newStatus };
            }
            return a;
          }),
        );
        triggerToast('อัปเดตสถานะผู้สมัครงานเรียบร้อยแล้ว');
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'ไม่สามารถอัปเดตสถานะได้'));
      }
    } catch (err) {
      triggerToast('เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
    }
  };

  const salaryMinNum = parseFloat(String(newJobForm.salaryMin || '').replace(/,/g, '')) || 0;
  const salaryMaxNum = parseFloat(String(newJobForm.salaryMax || '').replace(/,/g, '')) || 0;

  const isFormComplete = Boolean(
    newJobForm.title &&
      newJobForm.title.trim() &&
      newJobForm.category &&
      newJobForm.type &&
      newJobForm.province &&
      newJobForm.province.trim() &&
      newJobForm.district &&
      newJobForm.district.trim() &&
      newJobForm.location &&
      newJobForm.location.trim() &&
      salaryMinNum > 0 &&
      salaryMaxNum >= salaryMinNum &&
      newJobForm.description &&
      newJobForm.description.trim() &&
      newJobForm.qualifications &&
      newJobForm.qualifications.trim(),
  );

  const handlePostJobSubmit = async (e) => {
    e.preventDefault();
    const jobTitle = (newJobForm.title || '').trim();
    if (!jobTitle) {
      triggerToast('กรุณากรอกชื่อตำแหน่งงาน');
      return;
    }
    if (!newJobForm.category) {
      triggerToast('กรุณาเลือกหมวดหมู่วิชาชีพ');
      return;
    }
    if (!newJobForm.type) {
      triggerToast('กรุณาเลือกรูปแบบการจ้างงาน');
      return;
    }
    if (!newJobForm.province || !newJobForm.province.trim()) {
      triggerToast('กรุณาเลือกจังหวัดประจำตำแหน่งงาน');
      return;
    }
    if (!newJobForm.district || !newJobForm.district.trim()) {
      triggerToast('กรุณากรอกอำเภอ/เขตสถานที่ทำงาน');
      return;
    }
    if (!newJobForm.location || !newJobForm.location.trim()) {
      triggerToast('กรุณากรอกสถานที่ทำงาน / รายละเอียดที่อยู่');
      return;
    }
    if (salaryMinNum <= 0) {
      triggerToast('กรุณาระบุอัตราเงินเดือนเริ่มต้นให้ถูกต้อง');
      return;
    }
    if (salaryMaxNum < salaryMinNum) {
      triggerToast('อัตราเงินเดือนสูงสุดต้องไม่น้อยกว่าเงินเดือนเริ่มต้น');
      return;
    }
    if (!newJobForm.description || !newJobForm.description.trim()) {
      triggerToast('กรุณากรอกรายละเอียดหน้าที่ความรับผิดชอบ');
      return;
    }
    if (!newJobForm.qualifications || !newJobForm.qualifications.trim()) {
      triggerToast('กรุณากรอกคุณสมบัติผู้สมัคร');
      return;
    }

    let postLat = null;
    let postLng = null;

    if (
      geoCoords.status === 'found' &&
      Number.isFinite(geoCoords.lat) &&
      Number.isFinite(geoCoords.lng)
    ) {
      postLat = geoCoords.lat;
      postLng = geoCoords.lng;
    } else if (newJobForm.location) {
      const resolved = await resolveCoordinates(newJobForm.location);
      if (resolved) {
        postLat = resolved.lat;
        postLng = resolved.lng;
      }
    }

    const targetProvince = (newJobForm.province || '').trim() || 'กรุงเทพมหานคร';
    const targetDistrict = (newJobForm.district || '').trim();

    // Safe fallback to province centroid if geocoding fails or timed out
    if (postLat === null || postLng === null) {
      const provCoords = getProvinceCoords(targetProvince);
      if (provCoords) {
        const spread = spreadCoordsById(
          provCoords.lat,
          provCoords.lng,
          editingJobId || Date.now(),
        );
        postLat = spread.lat;
        postLng = spread.lng;
      } else {
        postLat = 13.7563;
        postLng = 100.5018;
      }
    }

    try {
      const { shopId, shopName } = getShopContext(permitdata);
      if (!shopId) {
        triggerToast('ไม่พบรหัสร้านค้า กรุณาเข้าสู่ระบบร้านค้าอีกครั้ง');
        return;
      }
      const employerUserId = shopId || permitdata?.user_id || '';
      const endpoint = editingJobId
        ? '/api/market/jobs/update_post'
        : '/api/market/jobs/create_post';
      const gallery = Array.isArray(newJobForm.galleryImages)
        ? newJobForm.galleryImages.filter(Boolean)
        : [];
      const clearingImages = gallery.length === 0;
      const payload = {
        job_id: editingJobId || undefined,
        employer_id: employerUserId,
        shop_id: shopId,
        company_name:
          shopName || permitdata?.shop_name || permitdata?.user_name || 'สถานพยาบาล/ร้านยา',
        company_logo: newJobForm.companyLogo || '',
        // Explicit clear fields — many backends ignore empty string / skip unchanged nulls
        poster_image: clearingImages ? null : gallery[0],
        gallery_images: clearingImages ? [] : gallery,
        gallery_images_json: JSON.stringify(gallery),
        clear_gallery: clearingImages ? 1 : 0,
        clear_poster: clearingImages ? 1 : 0,
        remove_poster_image: clearingImages ? 1 : 0,
        remove_gallery_images: clearingImages ? 1 : 0,
        title: jobTitle,
        category_id: (() => {
          const resolvedName =
            inferJobCategoryFromText(jobTitle) ||
            resolveJobCategory(jobTitle, newJobForm.category) ||
            newJobForm.category;
          return (
            JOB_CATEGORY_NAME_TO_ID[resolvedName] ||
            JOB_CATEGORY_NAME_TO_ID[newJobForm.category] ||
            3
          );
        })(),
        job_type: newJobForm.type || 'Full Time',
        salary_min: salaryMinNum,
        salary_max: salaryMaxNum,
        salary_type: 'monthly',
        salary_negotiable: false,
        experience_required: newJobForm.experience || 'ไม่ระบุ',
        education_level: newJobForm.education || 'ไม่ระบุ',
        company_website: newJobForm.website || '',
        description: newJobForm.description || 'รายละเอียดงานตามที่กำหนด',
        requirements: newJobForm.qualifications || 'มีใบประกอบวิชาชีพ',
        province: targetProvince,
        district: targetDistrict,
        address: newJobForm.location || targetProvince,
        lat: postLat,
        lng: postLng,
      };

      const res = await axios.post((app_hostname || '') + endpoint, payload);

      if (res.data && res.data.status === 'Success') {
        if (editingJobId) {
          if (clearingImages) markJobImagesCleared(editingJobId);
          else unmarkJobImagesCleared(editingJobId);
        }
        triggerToast(
          clearingImages
            ? 'บันทึกแล้ว และลบรูปโปสเตอร์ออกจากประกาศนี้แล้ว'
            : editingJobId
              ? '✅ บันทึกการแก้ไขประกาศงานเรียบร้อยแล้ว!'
              : 'เผยแพร่ประกาศรับสมัครงานเรียบร้อยแล้ว!',
        );
        setEditingJobId(null);
        fetchDashboardData();
        setActiveTab('manage_jobs');
      } else {
        triggerToast(getFriendlyErrorMsg(res.data?.message, 'ไม่สามารถบันทึกประกาศงานได้'));
      }
    } catch (err) {
      triggerToast('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
    }
  };

  if (!isShopMember) {
    return (
      <div className='employer-access-denied-wrap'>
        <div className='employer-access-denied-card'>
          <div className='employer-access-denied-icon'>
            <i className='mdi mdi-shield-lock-outline'></i>
          </div>
          <h2>พื้นที่เฉพาะสำหรับผู้ประกอบการ (Employers Only)</h2>
          <p className='employer-access-denied-desc'>
            หน้านี้สงวนสิทธิ์เฉพาะสถานพยาบาล คลินิก
            หรือร้านขายยาที่ต้องการลงประกาศรับสมัครงานและจัดการผู้สมัคร
          </p>
          <div className='employer-access-denied-info'>
            <i className='mdi mdi-information-outline'></i>
            <span>
              คุณกำลังเข้าสู่ระบบด้วยบัญชี <strong>ผู้สมัครงาน (Job Seeker)</strong>{' '}
              ซึ่งไม่มีสิทธิ์เข้าถึงส่วนนี้
            </span>
          </div>
          <div className='employer-access-denied-actions'>
            <button type='button' className='btn-denied-primary' onClick={() => navigate('/jobs')}>
              <i className='mdi mdi-briefcase-search-outline me-1'></i> ค้นหาตำแหน่งงาน
              (สำหรับผู้สมัครงาน)
            </button>
            <button type='button' className='btn-denied-secondary' onClick={() => navigate('/')}>
              <i className='mdi mdi-store-outline me-1'></i> ไปหน้าร้านค้า / เข้าสู่ระบบผู้ประกอบการ
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='employer-portal-container'>
      {/* Toast Notification */}
      {toastMsg && (
        <div className='employer-toast-floating'>
          <i className='mdi mdi-check-circle-outline'></i>
          <span>{toastMsg}</span>
        </div>
      )}

      {/* Header Banner */}
      <section className='employer-hero-header'>
        <div className='employer-header-content'>
          <div className='company-brand-row'>
            <div
              className='company-logo-avatar'
              onClick={() => shopLogoInputRef.current?.click()}
              title='คลิกเพื่อเปลี่ยนโลโก้สถานพยาบาล/ร้านค้าหลัก'
            >
              <img
                src={getLogoSrc(currentShopLogo)}
                alt='Company Logo'
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = meya_logo;
                }}
              />
              <div className='company-logo-upload-overlay'>
                <i
                  className={isUploadingShopLogo ? 'mdi mdi-loading mdi-spin' : 'mdi mdi-camera'}
                ></i>
                <span>{isUploadingShopLogo ? 'กำลังอัปโหลด...' : 'เปลี่ยนรูป'}</span>
              </div>
              <input
                type='file'
                ref={shopLogoInputRef}
                style={{ display: 'none' }}
                accept='image/png, image/jpeg, image/webp'
                onChange={handleShopLogoUpload}
              />
            </div>
            <div className='company-title-info'>
              <div className='company-badge-row'>
                <h2>{permitdata?.shop_name || 'สถานประกอบการของคุณ'}</h2>
                <span className='verified-employer-badge'>
                  <i className='mdi mdi-shield-check'></i> ยืนยันตัวตนสถานพยาบาลแล้ว
                </span>
              </div>
              <p>
                <i className='mdi mdi-map-marker-outline'></i>{' '}
                {permitdata?.province || permitdata?.shop_address || 'ที่ตั้งสถานประกอบการ'} |{' '}
                <i className='mdi mdi-hospital-building'></i>{' '}
                {permitdata?.shop_type || 'สถานพยาบาลและร้านขายยา'}
              </p>
            </div>
          </div>
          <button className='btn-post-new-job' onClick={startNewJobPost}>
            <i className='mdi mdi-plus-circle'></i> ลงประกาศรับสมัครงานใหม่
          </button>
        </div>
      </section>

      {/* Main Tab Navigation Bar */}
      <div className='employer-tab-nav'>
        <button
          className={`emp-tab-btn ${activeTab === 'manage_jobs' ? 'active' : ''}`}
          onClick={() => setActiveTab('manage_jobs')}
        >
          <i className='mdi mdi-format-list-bulleted'></i> จัดการประกาศรับสมัครงาน (
          {jobsList.length})
        </button>

        <button
          className={`emp-tab-btn ${activeTab === 'applicants' ? 'active' : ''}`}
          onClick={() => goToTab('applicants', { applicantFilter: 'all' })}
        >
          <i className='mdi mdi-account-box-multiple-outline'></i> ผู้สมัครงาน / เรซูเม่ (
          {applicantsList.length})
        </button>

        <button
          className={`emp-tab-btn ${activeTab === 'post_job' ? 'active' : ''}`}
          onClick={startNewJobPost}
        >
          <i className='mdi mdi-plus-box-outline'></i> สร้างประกาศงานใหม่
        </button>

        <button
          className={`emp-tab-btn ${activeTab === 'company_profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('company_profile')}
        >
          <i className='mdi mdi-hospital-building'></i> ข้อมูลสถานพยาบาล/ร้านค้า
        </button>
      </div>

      {/* Main Content Area */}
      <div className='employer-body-wrap'>
        {/* TAB 1: Manage Job Listings */}
        {activeTab === 'manage_jobs' && (
          <div className='emp-content-panel'>
            <div className='panel-header-row'>
              <div>
                <h3>รายการประกาศรับสมัครงานของคุณ</h3>
                <p>
                  จัดการเปิด-ปิดรับสมัคร แก้ไข หรือดูจำนวนผู้สมัครรายตำแหน่ง
                  {dashboardLoading
                    ? ' — กำลังโหลดข้อมูลทั้งหมด...'
                    : ` — โหลดแล้ว ${jobsList.length} ประกาศ`}
                </p>
              </div>
              <button className='btn-primary-gradient' onClick={startNewJobPost}>
                + เพิ่มตำแหน่งงานใหม่
              </button>
            </div>

            <div className='emp-job-search-bar'>
              <i className='mdi mdi-magnify'></i>
              <input
                type='text'
                value={jobListSearch}
                onChange={(e) => setJobListSearch(e.target.value)}
                placeholder='ค้นหาประกาศงาน เช่น ชื่อตำแหน่ง, สถานที่, รหัสงาน...'
              />
              {jobListSearch && (
                <button
                  type='button'
                  className='emp-job-search-clear'
                  onClick={() => setJobListSearch('')}
                >
                  ล้าง
                </button>
              )}
              <span className='emp-job-search-count'>
                {filteredJobsList.length}/{jobsList.length} รายการ
              </span>
            </div>

            <div className='job-manage-table-wrap'>
              <table className='emp-table'>
                <thead>
                  <tr>
                    <th>ตำแหน่งงาน / สถานที่</th>
                    <th>ประเภทงาน</th>
                    <th>เงินเดือน</th>
                    <th>ผู้สมัคร (คน)</th>
                    <th>เข้าชม</th>
                    <th>สถานะ</th>
                    <th>จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredJobsList.length === 0 ? (
                    <tr>
                      <td
                        colSpan={7}
                        style={{ textAlign: 'center', padding: '28px', color: colors.slate500 }}
                      >
                        {jobListSearch
                          ? `ไม่พบประกาศที่ตรงกับ "${jobListSearch}"`
                          : 'ยังไม่มีประกาศรับสมัครงาน'}
                      </td>
                    </tr>
                  ) : (
                    filteredJobsList.map((job) => (
                      <tr key={job.id}>
                        <td data-label='ตำแหน่งงาน'>
                          <div className='job-table-title'>
                            <strong>{job.title}</strong>
                            <span>
                              <i className='mdi mdi-map-marker-outline'></i> {job.location}
                            </span>
                          </div>
                        </td>
                        <td data-label='ประเภทงาน'>
                          <span className='badge-type'>{job.type}</span>
                        </td>
                        <td data-label='เงินเดือน'>
                          <strong className='text-success'>{job.salary}</strong>
                        </td>
                        <td data-label='ผู้สมัคร'>
                          <span
                            className='badge-applicants-count'
                            onClick={() =>
                              goToTab('applicants', {
                                applicantFilter: 'all',
                                jobId: job.id,
                                search: '',
                              })
                            }
                            title='ดูผู้สมัครตำแหน่งนี้'
                          >
                            <i className='mdi mdi-account-group'></i> {job.applicantsCount} คน
                          </span>
                        </td>
                        <td data-label='เข้าชม'>{job.viewsCount}</td>
                        <td data-label='สถานะ'>
                          <button
                            className={`btn-status-toggle ${job.status === 'active' ? 'active' : 'closed'}`}
                            onClick={() => handleToggleJobStatus(job.id)}
                          >
                            {job.status === 'active' ? '● เปิดรับสมัคร' : '○ ปิดรับสมัคร'}
                          </button>
                        </td>
                        <td data-label='จัดการ'>
                          <div className='table-action-btns'>
                            <button
                              className='btn-tbl-icon'
                              title='แก้ไข'
                              onClick={() => handleStartEditJob(job)}
                            >
                              <i className='mdi mdi-pencil-outline'></i>
                            </button>
                            <button
                              className='btn-tbl-icon text-danger'
                              title='ลบ'
                              onClick={() => handleDeleteJob(job.id)}
                            >
                              <i className='mdi mdi-trash-can-outline'></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* TAB 2: Applicants / Resumes Received */}
        {activeTab === 'applicants' && (
          <div className='emp-content-panel'>
            <div className='panel-header-row'>
              <div>
                <h3>
                  {applicantFilter === 'pending' ? 'รอพิจารณา' : 
                   applicantFilter === 'interview' ? 'นัดหมายสัมภาษณ์' : 
                   applicantFilter === 'hired' ? 'รับเข้าทำงาน' : 
                   applicantFilter === 'rejected' ? 'ไม่ผ่านการคัดเลือก' : 
                   'รายชื่อผู้สมัครงานและเรซูเม่ที่ได้รับ'}
                </h3>
                <p>
                  {applicantFilter === 'pending' ? 'รายชื่อผู้สมัครที่มีสถานะรอพิจารณา' : 
                   applicantFilter === 'interview' ? 'รายชื่อผู้สมัครที่มีสถานะนัดสัมภาษณ์' : 
                   applicantFilter === 'hired' ? 'รายชื่อผู้สมัครที่รับเข้าทำงานแล้ว' : 
                   applicantFilter === 'rejected' ? 'รายชื่อผู้สมัครที่ไม่ผ่านการคัดเลือก' : 
                   'พิจารณาคุณสมบัติผู้สมัคร นัดหมายสัมภาษณ์ หรือเปลี่ยนสถานะการคัดเลือก'}
                </p>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap', padding: '0 20px' }}>
              <button
                type='button'
                className='btn-action-outline'
                onClick={() => setApplicantFilter('all')}
                style={applicantFilter === 'all' ? { backgroundColor: colors.sky700, color: colors.white, borderColor: colors.sky700 } : {}}
              >
                ทั้งหมด (ไม่รวมไม่ผ่าน)
              </button>
              <button
                type='button'
                className='btn-action-outline'
                onClick={() => setApplicantFilter('pending')}
                style={applicantFilter === 'pending' ? { backgroundColor: colors.sky700, color: colors.white, borderColor: colors.sky700 } : {}}
              >
                 รอพิจารณา
              </button>
              <button
                type='button'
                className='btn-action-outline'
                onClick={() => setApplicantFilter('interview')}
                style={applicantFilter === 'interview' ? { backgroundColor: colors.sky700, color: colors.white, borderColor: colors.sky700 } : {}}
              >
                 นัดสัมภาษณ์
              </button>
              <button
                type='button'
                className='btn-action-outline'
                onClick={() => setApplicantFilter('hired')}
                style={applicantFilter === 'hired' ? { backgroundColor: colors.sky700, color: colors.white, borderColor: colors.sky700 } : {}}
              >
                 รับเข้าทำงาน
              </button>
              <button
                type='button'
                className='btn-action-outline'
                onClick={() => setApplicantFilter('rejected')}
                style={applicantFilter === 'rejected' ? { backgroundColor: colors.sky700, color: colors.white, borderColor: colors.sky700 } : {}}
              >
                 ไม่ผ่านการคัดเลือก
              </button>
            </div>

            <div className='emp-job-search-bar'>
              <i className='mdi mdi-magnify'></i>
              <input
                type='text'
                value={applicantSearch}
                onChange={(e) => setApplicantSearch(e.target.value)}
                placeholder='ค้นหาผู้สมัคร เช่น ชื่อ, เบอร์โทร, ตำแหน่งที่สมัคร...'
              />
              {(applicantSearch || applicantJobFilter) && (
                <button
                  type='button'
                  className='emp-job-search-clear'
                  onClick={() => {
                    setApplicantSearch('');
                    setApplicantJobFilter('');
                  }}
                >
                  ล้างตัวกรอง
                </button>
              )}
              <span className='emp-job-search-count'>
                {filteredApplicants.length}/{applicantsList.length} คน
              </span>
            </div>
            {applicantJobFilter && (
              <div style={{ marginBottom: 12, fontSize: 13, color: colors.sky700 }}>
                <i className='mdi mdi-filter-outline'></i> กำลังกรองผู้สมัครของประกาศ{' '}
                <strong>
                  {jobsList.find((j) => String(j.id) === String(applicantJobFilter))?.title ||
                    applicantJobFilter}
                </strong>
              </div>
            )}

            <div className='applicants-grid-cards'>
              {filteredApplicants.length === 0 && (
                <div className='empty-applicants-state'>ไม่พบผู้สมัครในหมวดนี้</div>
              )}
              {filteredApplicants.map((applicant) => (
                <div className='applicant-card-item' key={applicant.id}>
                  <div className='applicant-card-header'>
                    {applicant.avatar && !applicantImgErrors[applicant.id] ? (
                      <img
                        src={applicant.avatar}
                        alt={applicant.name}
                        className='applicant-avatar'
                        onError={() => handleApplicantImgError(applicant.id)}
                      />
                    ) : (
                      <div className='applicant-avatar-placeholder'>
                        <i className='mdi mdi-account'></i>
                      </div>
                    )}
                    <div>
                      <h4
                        className='applicant-name-clickable'
                        style={{ cursor: 'pointer', color: colors.sky700 }}
                        onClick={() => {
                          const targetId = applicant.seekerId || applicant.seeker_id || '';
                          navigate(`/jobs?mode=candidates&candidateId=${targetId}`);
                        }}
                      >
                        {applicant.name}
                      </h4>
                      <span className='applied-job-tag'>{applicant.appliedJob}</span>
                    </div>
                  </div>

                  <div className='applicant-info-details'>
                    <div>
                      <i className='mdi mdi-briefcase-outline'></i> ประสบการณ์:{' '}
                      <strong>{applicant.experience}</strong>
                    </div>
                    <div>
                      <i className='mdi mdi-currency-usd'></i> เงินเดือนที่คาดหวัง:{' '}
                      <strong className='text-success'>{applicant.expectedSalary}</strong>
                    </div>
                    <div>
                      <i className='mdi mdi-clock-outline'></i> วันที่สมัคร: {applicant.appliedDate}
                    </div>
                    <div>
                      <i className='mdi mdi-email-outline'></i> {applicant.email}
                    </div>
                  </div>

                  <div className='applicant-status-select-row'>
                    <label>สถานะ:</label>
                    <select
                      value={applicant.status}
                      onChange={(e) => {
                        if (e.target.value === 'interview') {
                          setSelectedApplicant(applicant);
                        } else {
                          handleUpdateApplicantStatus(applicant.id, e.target.value);
                        }
                      }}
                      className={`select-status-badge ${applicant.status}`}
                    >
                      <option value='pending'> รอพิจารณา</option>
                      <option value='interview'> นัดสัมภาษณ์</option>
                      <option value='hired'> รับเข้าทำงาน</option>
                      <option value='rejected'> ไม่ผ่านการคัดเลือก</option>
                    </select>
                  </div>

                  <div className='applicant-card-actions'>
                    <button
                      className='btn-action-outline'
                      onClick={() => {
                        const targetId = applicant.seekerId || applicant.seeker_id || '';
                        navigate(`/jobs?mode=candidates&candidateId=${targetId}`);
                      }}
                    >
                      <i className='mdi mdi-file-document-outline'></i> ดูโปรไฟล์เต็ม
                    </button>
                    <button
                      className='btn-action-primary'
                      onClick={() => setSelectedApplicant(applicant)}
                    >
                      <i className='mdi mdi-phone'></i> นัดสัมภาษณ์
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* TAB 3: Post New Job Form */}
        {activeTab === 'post_job' && (
          <div className='emp-content-panel'>
            <div className='panel-header-row'>
              <div>
                <h3>
                  {editingJobId
                    ? 'แก้ไขประกาศรับสมัครงาน (Edit Job Post)'
                    : 'ลงประกาศรับสมัครงานใหม่ (Post a Job)'}
                </h3>
                <p>
                  {editingJobId
                    ? `แก้ไขรายละเอียดและคุณสมบัติของตำแหน่งงานรหัส ${editingJobId}`
                    : 'สร้างประกาศรับสมัครงานบุคลากรทางการแพทย์เพื่อเข้าถึงผู้หางานทั่วประเทศ'}
                </p>
              </div>
              {editingJobId && (
                <button type='button' className='btn-action-outline' onClick={handleCancelEdit}>
                  <i className='mdi mdi-close'></i> ยกเลิกการแก้ไข
                </button>
              )}
            </div>

            <form onSubmit={handlePostJobSubmit} className='post-job-form'>
              <div className='form-section-card'>
                <h4>1. ข้อมูลตำแหน่งงาน</h4>
                <div className='form-grid-2'>
                  <div className='emp-field-group'>
                    <label>
                      ชื่อตำแหน่งงาน <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='เช่น เภสัชกรประจำร้านยา, พยาบาลวิชาชีพ ICU'
                      value={newJobForm.title}
                      onChange={(e) => {
                        const nextTitle = e.target.value;
                        const inferred = inferJobCategoryFromText(nextTitle);
                        setNewJobForm({
                          ...newJobForm,
                          title: nextTitle,
                          ...(inferred
                            ? {
                                category: inferred === 'พยาบาล' ? 'พยาบาลวิชาชีพ' : inferred,
                              }
                            : {}),
                        });
                      }}
                    />
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      สายงาน / วิชาชีพ <span className='text-danger'>*</span>
                    </label>
                    <select
                      value={newJobForm.category}
                      onChange={(e) => setNewJobForm({ ...newJobForm, category: e.target.value })}
                    >
                      <option value='เภสัชกร'>เภสัชกร</option>
                      <option value='ผู้ช่วยเภสัชกร'>ผู้ช่วยเภสัชกร</option>
                      <option value='พยาบาลวิชาชีพ'>พยาบาลวิชาชีพ</option>
                      <option value='ผู้ช่วยพยาบาล'>ผู้ช่วยพยาบาล</option>
                      <option value='แพทย์'>แพทย์</option>
                      <option value='เทคนิคการแพทย์'>เทคนิคการแพทย์</option>
                      <option value='ทันตแพทย์'>ทันตแพทย์</option>
                      <option value='นักกายภาพบำบัด'>นักกายภาพบำบัด</option>
                      <option value='รังสีเทคนิค'>รังสีเทคนิค</option>
                      <option value='เจ้าหน้าที่สาธารณสุข'>เจ้าหน้าที่สาธารณสุข</option>
                    </select>
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      รูปแบบการจ้างงาน <span className='text-danger'>*</span>
                    </label>
                    <select
                      value={newJobForm.type}
                      onChange={(e) => setNewJobForm({ ...newJobForm, type: e.target.value })}
                    >
                      <option value='Full Time'>Full Time (งานประจำ)</option>
                      <option value='Part Time'>Part Time (งานพาร์ทไทม์)</option>
                      <option value='Contract'>สัญญาจ้าง (Contract)</option>
                    </select>
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      ประสบการณ์ <span className='text-danger'>*</span>
                    </label>
                    <select
                      value={newJobForm.experience}
                      onChange={(e) => setNewJobForm({ ...newJobForm, experience: e.target.value })}
                    >
                      <option value='ไม่ระบุ'>ไม่ระบุ</option>
                      <option value='ยินดีรับนักศึกษาจบใหม่'>ยินดีรับนักศึกษาจบใหม่</option>
                      <option value='1-2 ปี'>1-2 ปี</option>
                      <option value='3-5 ปี'>3-5 ปี</option>
                      <option value='5 ปีขึ้นไป'>5 ปีขึ้นไป</option>
                    </select>
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      ระดับการศึกษา <span className='text-danger'>*</span>
                    </label>
                    <select
                      value={newJobForm.education}
                      onChange={(e) => setNewJobForm({ ...newJobForm, education: e.target.value })}
                    >
                      <option value='ไม่ระบุ'>ไม่ระบุ</option>
                      <option value='ต่ำกว่าปริญญาตรี'>ต่ำกว่าปริญญาตรี</option>
                      <option value='ปริญญาตรี'>ปริญญาตรี</option>
                      <option value='ปริญญาโท'>ปริญญาโท</option>
                      <option value='ปริญญาเอก'>ปริญญาเอก</option>
                    </select>
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      จังหวัดประจำตำแหน่งงาน <span className='text-danger'>*</span>
                    </label>
                    <select
                      value={newJobForm.province}
                      onChange={(e) => {
                        const prov = e.target.value;
                        setNewJobForm((prev) => ({
                          ...prev,
                          province: prov,
                        }));
                        const provCoords = getProvinceCoords(prov);
                        if (provCoords) {
                          setGeoCoords({
                            lat: provCoords.lat,
                            lng: provCoords.lng,
                            status: 'found',
                            displayName: prov,
                          });
                        }
                      }}
                    >
                      <option value=''>-- กรุณาเลือกจังหวัด --</option>
                      {THAI_PROVINCES.map((prov) => (
                        <option key={prov} value={prov}>
                          {prov}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      อำเภอ / เขต <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      placeholder='เช่น อำเภอพนมทวน, อำเภอศรีราชา, เขตบางนา'
                      value={newJobForm.district}
                      onChange={(e) =>
                        setNewJobForm((prev) => ({
                          ...prev,
                          district: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className='emp-field-group full-width'>
                    <label>
                      สถานที่ทำงาน / รายละเอียดที่อยู่ <span className='text-danger'>*</span>{' '}
                      <span style={{ fontSize: 12, color: colors.slate500 }}>
                        (ระบุชื่อสาขา ซอย ถนน หรือดึงจากโปรไฟล์ร้านค้า)
                      </span>
                    </label>
                    <input
                      type='text'
                      placeholder='เช่น 233/43 ถนนสรรพาวุธ สาขาตลาดเขต'
                      value={newJobForm.location}
                      onChange={(e) => {
                        const nextLocation = e.target.value;
                        const nextProvince = detectProvinceFromText(nextLocation);
                        setNewJobForm((prev) => ({
                          ...prev,
                          location: nextLocation,
                          ...(nextProvince ? { province: nextProvince } : {}),
                        }));
                        if (nextProvince) {
                          const provCoords = getProvinceCoords(nextProvince);
                          if (provCoords) {
                            setGeoCoords({
                              lat: provCoords.lat,
                              lng: provCoords.lng,
                              status: 'found',
                              displayName: nextProvince,
                            });
                          }
                        }
                      }}
                    />
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      เว็บไซต์บริษัท <span style={{ fontSize: 12, color: colors.slate500 }}>(ถ้ามี)</span>
                    </label>
                    <input
                      type='text'
                      placeholder='เช่น https://'
                      value={newJobForm.website}
                      onChange={(e) =>
                        setNewJobForm((prev) => ({
                          ...prev,
                          website: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className='emp-field-group full-width'>
                    <div
                      style={{
                        marginTop: 6,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                        fontSize: 12,
                      }}
                    >
                      {isGeocoding ? (
                        <span
                          style={{
                            color: colors.sky600,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                          }}
                        >
                          <i className='mdi mdi-loading mdi-spin'></i>{' '}
                          กำลังค้นหาพิกัดแผนที่อัตโนมัติ...
                        </span>
                      ) : geoCoords.status === 'found' &&
                        Number.isFinite(geoCoords.lat) &&
                        Number.isFinite(geoCoords.lng) ? (
                        <span
                          style={{
                            color: '#15803d',
                            background: colors.green50,
                            border: '1px solid #bbf7d0',
                            padding: '2px 8px',
                            borderRadius: 4,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                          }}
                        >
                          <i className='mdi mdi-map-marker-check'></i>
                          ตรวจพบพิกัด: [{geoCoords.lat.toFixed(4)}, {geoCoords.lng.toFixed(4)}]
                        </span>
                      ) : (
                        <span style={{ color: colors.slate500 }}>
                          <i className='mdi mdi-information-outline'></i>{' '}
                          ระบบจะแปลงที่อยู่ร้านหรือใช้พิกัดประจำจังหวัดให้อัตโนมัติ
                        </span>
                      )}
                    </div>
                  </div>

                  <div className='emp-field-group full-width mt-3'>
                    <label>
                      1. โลโก้สถานพยาบาล / ร้านค้า (Company Logo){' '}
                      <span
                        style={{
                          fontSize: 12,
                          color:
                            newJobForm.companyLogo === currentShopLogo && currentShopLogo
                              ? colors.sky600
                              : colors.slate500,
                          fontWeight:
                            newJobForm.companyLogo === currentShopLogo && currentShopLogo
                              ? '600'
                              : 'normal',
                        }}
                      >
                        {newJobForm.companyLogo === currentShopLogo && currentShopLogo
                          ? '✨ ใช้โลโก้หลักของร้านค้าอัตโนมัติ (สามารถกดเปลี่ยนเฉพาะประกาศนี้ได้)'
                          : 'สัดส่วน 1:1 แนะนำรูปจัตุรัสหรือวงกลม (แสดงบนหัวการ์ดงาน, ข้อมูลบริษัท, และหมุดแผนที่)'}
                      </span>
                    </label>
                    <div className='d-flex align-items-center gap-3 mt-1'>
                      {newJobForm.companyLogo && (
                        <div
                          style={{
                            width: 56,
                            height: 56,
                            borderRadius: 8,
                            overflow: 'hidden',
                            border: '1px solid #e2e8f0',
                            background: colors.white,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img
                            src={
                              newJobForm.companyLogo.startsWith('http')
                                ? newJobForm.companyLogo
                                : (app_hostname || '') + newJobForm.companyLogo
                            }
                            alt='Logo'
                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                          />
                        </div>
                      )}
                      <div className='d-flex align-items-center gap-2 flex-wrap'>
                        <input
                          type='file'
                          accept='image/png, image/jpeg, image/webp'
                          id='job-logo-upload'
                          style={{ display: 'none' }}
                          onChange={handleImageUpload}
                        />
                        <label
                          htmlFor='job-logo-upload'
                          className='btn-action-outline'
                          style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            margin: 0,
                          }}
                        >
                          <i className='mdi mdi-cloud-upload-outline'></i>{' '}
                          {isUploadingImage
                            ? 'กำลังอัปโหลด...'
                            : newJobForm.companyLogo
                              ? 'เปลี่ยนโลโก้เฉพาะงานนี้'
                              : 'อัปโหลดโลโก้บริษัท'}
                        </label>
                        {newJobForm.companyLogo !== currentShopLogo && currentShopLogo && (
                          <button
                            type='button'
                            className='btn-action-outline'
                            style={{ margin: 0, color: colors.sky600, borderColor: colors.sky200 }}
                            onClick={() =>
                              setNewJobForm((prev) => ({ ...prev, companyLogo: currentShopLogo }))
                            }
                          >
                            <i className='mdi mdi-refresh'></i> ใช้โลโก้หลักของร้าน
                          </button>
                        )}
                        <span style={{ fontSize: 12, color: colors.slate500 }}>
                          รองรับ JPG, PNG, WEBP (สูงสุด 5MB)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className='emp-field-group full-width mt-3'>
                    <label>
                      2. รูปภาพโปสเตอร์และบรรยากาศสถานที่ทำงาน (Job Poster & Workplace Gallery)
                      <span
                        style={{ fontSize: 12, color: colors.slate500, display: 'block', marginTop: 2 }}
                      >
                        สามารถลงรูปเดียว หรือหลายรูป (แนะนำ 3 รูปขึ้นไปเพื่อแสดงบรรยากาศการทำงาน
                        หากลงรูปเดียวระบบจะแสดงเฉพาะรูปนั้น)
                      </span>
                    </label>

                    {/* Gallery Thumbnails Grid */}
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 12,
                        marginTop: 8,
                        alignItems: 'center',
                      }}
                    >
                      {(Array.isArray(newJobForm.galleryImages)
                        ? newJobForm.galleryImages
                        : newJobForm.posterImage
                          ? [newJobForm.posterImage]
                          : []
                      ).map((imgUrl, idx) => (
                        <div
                          key={idx}
                          style={{
                            position: 'relative',
                            width: 80,
                            height: 105,
                            borderRadius: 8,
                            overflow: 'hidden',
                            border: idx === 0 ? '2px solid #0284c7' : '1px solid #cbd5e1',
                            background: colors.slate50,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.06)',
                          }}
                        >
                          <img
                            src={imgUrl.startsWith('http') ? imgUrl : (app_hostname || '') + imgUrl}
                            alt={`Gallery ${idx + 1}`}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                          <span
                            style={{
                              position: 'absolute',
                              bottom: 0,
                              left: 0,
                              right: 0,
                              background:
                                idx === 0 ? 'rgba(2, 132, 199, 0.9)' : 'rgba(15, 23, 42, 0.75)',
                              color: colors.white,
                              fontSize: 10,
                              textAlign: 'center',
                              padding: '2px 0',
                              fontWeight: 600,
                            }}
                          >
                            {idx === 0 ? 'รูปหน้าปก' : `รูปที่ ${idx + 1}`}
                          </span>
                          <button
                            type='button'
                            onClick={() => handleRemoveGalleryImage(idx)}
                            style={{
                              position: 'absolute',
                              top: 2,
                              right: 2,
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              background: 'rgba(239, 68, 68, 0.9)',
                              color: colors.white,
                              border: 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: 12,
                              cursor: 'pointer',
                              padding: 0,
                              lineHeight: 1,
                            }}
                            title='ลบรูปนี้'
                          >
                            &times;
                          </button>
                        </div>
                      ))}

                      {/* Upload Button */}
                      {(!Array.isArray(newJobForm.galleryImages) ||
                        newJobForm.galleryImages.length < 6) && (
                        <div>
                          <input
                            type='file'
                            accept='image/png, image/jpeg, image/webp'
                            id='job-poster-upload'
                            style={{ display: 'none' }}
                            multiple
                            onChange={handleAddGalleryImage}
                          />
                          <label
                            htmlFor='job-poster-upload'
                            className='btn-action-outline'
                            style={{
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 6,
                              margin: 0,
                              padding: '10px 16px',
                              borderRadius: 8,
                              border: '1.5px dashed #0284c7',
                              color: colors.sky600,
                              background: '#f0f9ff',
                            }}
                          >
                            <i className='mdi mdi-plus-circle-outline' style={{ fontSize: 18 }}></i>
                            {isUploadingPoster
                              ? 'กำลังอัปโหลด...'
                              : newJobForm.galleryImages && newJobForm.galleryImages.length > 0
                                ? '+ เพิ่มรูปภาพ'
                                : 'อัปโหลดโปสเตอร์ / รูปบรรยากาศ'}
                          </label>
                        </div>
                      )}
                    </div>
                    <span
                      style={{ fontSize: 11, color: colors.slate500, display: 'block', marginTop: 6 }}
                    >
                      รองรับ JPG, PNG, WEBP (สูงสุด 5MB ต่อรูป, อัปโหลดได้สูงสุด 6 รูป)
                    </span>
                  </div>
                </div>
              </div>

              <div className='form-section-card mt-4'>
                <h4>2. ผลตอบแทนและสวัสดิการ</h4>
                <div className='form-grid-2'>
                  <div className='emp-field-group'>
                    <label>
                      เงินเดือนเริ่มต้น (บาท) <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      value={newJobForm.salaryMin}
                      onChange={(e) => setNewJobForm({ ...newJobForm, salaryMin: e.target.value })}
                    />
                  </div>

                  <div className='emp-field-group'>
                    <label>
                      เงินเดือนสูงสุด (บาท) <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      value={newJobForm.salaryMax}
                      onChange={(e) => setNewJobForm({ ...newJobForm, salaryMax: e.target.value })}
                    />
                  </div>
                </div>

                <div className='emp-field-group mt-3'>
                  <label>สวัสดิการสถานพยาบาล/ร้านยา</label>
                  <div className='benefits-checkbox-grid'>
                    {[
                      'ค่าใบประกอบวิชาชีพ',
                      'ประกันสังคม',
                      'โบนัสประจำปี',
                      'ประกันสุขภาพกลุ่ม',
                      'โอที (OT)',
                      'ที่พักฟรี/ค่าหอพัก',
                      'คอร์สอบรมฟรี',
                    ].map((b) => (
                      <label key={b} className='benefit-item'>
                        <input
                          type='checkbox'
                          checked={(newJobForm.benefits || []).includes(b)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setNewJobForm((prev) => ({
                                ...prev,
                                benefits: [...(prev.benefits || []), b],
                              }));
                            } else {
                              setNewJobForm((prev) => ({
                                ...prev,
                                benefits: (prev.benefits || []).filter((item) => item !== b),
                              }));
                            }
                          }}
                        />
                        <span>{b}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              <div className='form-section-card mt-4'>
                <h4>3. รายละเอียดงานและคุณสมบัติ</h4>
                <div className='emp-field-group mb-3'>
                  <label>
                    รายละเอียดงานและหน้าที่ความรับผิดชอบ <span className='text-danger'>*</span>
                  </label>
                  <textarea
                    rows='4'
                    placeholder='ระบุรายละเอียดงาน หน้าที่ความรับผิดชอบในแต่ละวัน...'
                    value={newJobForm.description}
                    onChange={(e) => setNewJobForm({ ...newJobForm, description: e.target.value })}
                  ></textarea>
                </div>

                <div className='emp-field-group'>
                  <label>
                    คุณสมบัติผู้สมัคร <span className='text-danger'>*</span>
                  </label>
                  <textarea
                    rows='3'
                    placeholder='ระบุวุฒิการศึกษา ใบอนุญาตประกอบวิชาชีพ ประสบการณ์...'
                    value={newJobForm.qualifications}
                    onChange={(e) =>
                      setNewJobForm({ ...newJobForm, qualifications: e.target.value })
                    }
                  ></textarea>
                </div>
              </div>

              <div className='post-job-action-bar'>
                <button type='button' className='btn-outline-cancel' onClick={handleCancelEdit}>
                  ยกเลิก
                </button>
                <button
                  type='submit'
                  className={`btn-primary-gradient ${!isFormComplete ? 'disabled' : ''}`}
                  disabled={!isFormComplete}
                  title={
                    !isFormComplete
                      ? 'กรุณากรอกข้อมูลในช่องที่มีเครื่องหมายดอกจัน (*) ให้ครบถ้วน'
                      : ''
                  }
                >
                  <i
                    className={
                      editingJobId ? 'mdi mdi-content-save-outline' : 'mdi mdi-send-outline'
                    }
                  ></i>{' '}
                  {editingJobId ? 'บันทึกการแก้ไขประกาศงาน' : 'เผยแพร่ประกาศรับสมัครงาน'}
                </button>
              </div>
              {!isFormComplete && (
                <div
                  style={{
                    textAlign: 'right',
                    marginTop: 10,
                    fontSize: 13,
                    color: '#e11d48',
                    fontWeight: 500,
                  }}
                >
                  <i className='mdi mdi-alert-circle-outline me-1'></i>{' '}
                  กรุณากรอกข้อมูลในช่องที่มีเครื่องหมายดอกจัน (*) ให้ครบถ้วนเพื่อเปิดใช้งานปุ่มบันทึก
                </div>
              )}
            </form>
          </div>
        )}

        {/* TAB 4: Company / Hospital Profile */}
        {activeTab === 'company_profile' && (
          <div className='emp-content-panel'>
            <div className='panel-header-row'>
              <div>
                <h3>โปรไฟล์สถานพยาบาล / ร้านค้า (Company Profile)</h3>
                <p>จัดการข้อมูลทั่วไป โลโก้ และช่องทางติดต่อสถานพยาบาลของคุณ</p>
              </div>
              <div className='d-flex align-items-center gap-2'>
                <span className='badge bg-light text-muted border p-2' style={{ fontSize: 13 }}>
                  <i className='mdi mdi-information-outline me-1'></i> ข้อมูลทะเบียนร้านค้า Meya
                </span>
              </div>
            </div>

            <div
              style={{
                background: colors.slate50,
                border: '1px solid #e2e8f0',
                borderRadius: 8,
                padding: '12px 16px',
                marginBottom: 20,
                color: colors.slate600,
                fontSize: 13,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
              }}
            >
              <i
                className='mdi mdi-shield-check-outline'
                style={{ fontSize: 20, color: colors.blue500 }}
              ></i>
              <span>
                ข้อมูลสถานประกอบการและที่อยู่หลักเชื่อมต่อกับระบบทะเบียนร้านค้าของ Meya
                หากต้องการแก้ไขข้อมูลทะเบียน
                กรุณาติดต่อผู้ดูแลระบบหรือแก้ไขผ่านหน้าตั้งค่าร้านค้าหลัก
                ส่วนโลโก้สามารถอัปเดตเพื่อใช้ในระบบประกาศงานได้ทันที
              </span>
            </div>

            <div className='company-edit-grid'>
              <div className='emp-field-group full-width mb-3'>
                <label>
                  โลโก้สถานพยาบาล / ร้านค้าหลัก (Master Shop Logo){' '}
                  <span style={{ fontSize: 12, color: colors.slate500 }}>
                    (โลโก้นี้จะถูกนำไปใช้เป็นค่าตั้งต้นของทุกประกาศรับสมัครงาน)
                  </span>
                </label>
                <div className='d-flex align-items-center gap-3 mt-1'>
                  <div
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: 12,
                      overflow: 'hidden',
                      border: '2px solid #e2e8f0',
                      background: colors.white,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={getLogoSrc(currentShopLogo)}
                      alt='Shop Logo'
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = meya_logo;
                      }}
                    />
                  </div>
                  <div>
                    <button
                      type='button'
                      className='btn-action-outline'
                      onClick={() => shopLogoInputRef.current?.click()}
                      disabled={isUploadingShopLogo}
                    >
                      <i
                        className={
                          isUploadingShopLogo ? 'mdi mdi-loading mdi-spin' : 'mdi mdi-camera'
                        }
                      ></i>{' '}
                      {isUploadingShopLogo ? 'กำลังอัปโหลด...' : 'เปลี่ยนโลโก้ร้านค้า'}
                    </button>
                    <span style={{ fontSize: 12, color: colors.slate500, marginLeft: 10 }}>
                      รองรับ JPG, PNG, WEBP (สูงสุด 5MB)
                    </span>
                  </div>
                </div>
              </div>

              <div className='emp-field-group'>
                <label>ชื่อสถานพยาบาล/บริษัท (ภาษาไทย)</label>
                <input
                  type='text'
                  defaultValue={permitdata?.shop_name || ''}
                  readOnly
                  style={{ background: colors.slate100, cursor: 'default' }}
                />
              </div>

              <div className='emp-field-group'>
                <label>ชื่อสถานพยาบาล/บริษัท (English)</label>
                <input
                  type='text'
                  defaultValue={permitdata?.shop_name_en || ''}
                  readOnly
                  style={{ background: colors.slate100, cursor: 'default' }}
                />
              </div>

              <div className='emp-field-group'>
                <label>ประเภทสถานประกอบการ</label>
                <select
                  defaultValue={permitdata?.shop_type || 'ร้านขายยา'}
                  disabled
                  style={{ background: colors.slate100, cursor: 'default' }}
                >
                  <option value='ร้านขายยา'>ร้านขายยา / ร้านยาคุณภาพ</option>
                  <option value='โรงพยาบาลเอกชน'>โรงพยาบาลเอกชน</option>
                  <option value='คลินิกเวชกรรม/ความงาม'>คลินิกเวชกรรม / คลินิกความงาม</option>
                  <option value='ศูนย์บริการสุขภาพ'>ศูนย์บริการสุขภาพ / กายภาพบำบัด</option>
                </select>
              </div>

              <div className='emp-field-group'>
                <label>เบอร์โทรศัพท์ติดต่อ HR</label>
                <input
                  type='tel'
                  defaultValue={permitdata?.shop_phone || permitdata?.phone || ''}
                  readOnly
                  style={{ background: colors.slate100, cursor: 'default' }}
                />
              </div>

              <div className='emp-field-group full-width'>
                <label>ที่ตั้งสถานพยาบาล / สาขาใหญ่</label>
                <input
                  type='text'
                  defaultValue={permitdata?.shop_address || ''}
                  readOnly
                  style={{ background: colors.slate100, cursor: 'default' }}
                />
              </div>

              <div className='emp-field-group full-width'>
                <label>เกี่ยวกับสถานพยาบาล / วิสัยทัศน์องค์กร</label>
                <textarea
                  rows='4'
                  defaultValue={permitdata?.shop_description || ''}
                  readOnly
                  style={{ background: colors.slate100, cursor: 'default' }}
                ></textarea>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Schedule Interview Modal */}
      {selectedApplicant && (() => {
        const handleCloseInterviewModal = () => {
          setSelectedApplicant(null);
          setInterviewNotes('');
          setInterviewDate(dayjs());
          setInterviewTime(dayjs('10:30', 'HH:mm'));
          setInterviewChannel('onsite');
        };

        return (
          <div className='employer-modal-overlay' onClick={handleCloseInterviewModal}>
            <div className='employer-modal-box' onClick={(e) => e.stopPropagation()}>
              <div className='modal-header-row'>
                <h3>นัดหมายสัมภาษณ์งาน: {selectedApplicant.name}</h3>
                <button className='btn-close' onClick={handleCloseInterviewModal}>
                  &times;
                </button>
              </div>
              <div className='modal-body-content'>
                <p>
                  ตำแหน่ง: <strong>{selectedApplicant.appliedJob}</strong>
                </p>
                <div className='emp-field-group mb-3'>
                  <label>วันที่นัดสัมภาษณ์</label>
                  <ConfigProvider locale={thTH}>
                    <DatePicker 
                      value={interviewDate} 
                      onChange={(val) => setInterviewDate(val)}
                      format="DD/MM/BBBB" 
                      allowClear={false}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      style={{ width: '100%', height: '44px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', fontFamily: 'inherit' }} 
                    />
                  </ConfigProvider>
                </div>
                <div className='emp-field-group mb-3'>
                  <label>เวลานัดหมาย</label>
                  <TimePicker 
                    value={interviewTime} 
                    onChange={(val) => setInterviewTime(val)}
                    format="HH:mm" 
                    allowClear={false}
                    showNow={false}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    style={{ width: '100%', height: '44px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', fontFamily: 'inherit' }} 
                  />
                </div>
                <div className='emp-field-group mb-3' style={{ background: colors.slate50, padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                  <p style={{ margin: 0, fontSize: '14px', color: colors.slate700 }}>
                    <strong><i className='mdi mdi-email-outline'></i> อีเมลผู้สมัคร:</strong>{' '}
                    {selectedApplicant.email && selectedApplicant.email !== '-' ? (
                      <a href={`mailto:${selectedApplicant.email}?subject=นัดหมายสัมภาษณ์งานตำแหน่ง ${selectedApplicant.appliedJob}`} style={{ color: colors.sky600, textDecoration: 'underline' }}>
                        {selectedApplicant.email}
                      </a>
                    ) : '-'}
                    <br/>
                    <strong style={{ marginTop: '6px', display: 'inline-block' }}>
                      <i className='mdi mdi-phone-outline'></i> เบอร์โทรศัพท์:
                    </strong>{' '}
                    {selectedApplicant.phone && selectedApplicant.phone !== '-' ? (
                      <a href={`tel:${selectedApplicant.phone}`} style={{ color: colors.sky600, textDecoration: 'underline' }}>
                        {selectedApplicant.phone}
                      </a>
                    ) : '-'}
                  </p>
                  <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: colors.red500, lineHeight: '1.4' }}>
                    * ระบบยังไม่มีการส่งลิงก์วิดีโอคอลหรือแจ้งเตือนทางอีเมลอัตโนมัติ กรุณาติดต่อนัดหมายผู้สมัครโดยตรงผ่านช่องทางด้านบน
                  </p>
                </div>

                <div className='emp-field-group mb-3'>
                  <label>รูปแบบ / ช่องทางการสัมภาษณ์</label>
                  <select value={interviewChannel} onChange={(e) => setInterviewChannel(e.target.value)}>
                    <option value='onsite'>สัมภาษณ์ที่สถานพยาบาล (On-site)</option>
                    <option value='phone'>สัมภาษณ์ทางโทรศัพท์</option>
                    <option value='email'>พูดคุยผ่านทางอีเมล</option>
                  </select>
                </div>

                <div className='emp-field-group mb-3'>
                  <label>ข้อความ / รายละเอียดเพิ่มเติมถึงผู้สมัคร</label>
                  <textarea
                    rows={3}
                    placeholder='เช่น เอกสารที่ต้องเตรียม, ลิงก์ห้องสัมภาษณ์ออนไลน์, หรือสถานที่นัดพบ...'
                    value={interviewNotes}
                    onChange={(e) => setInterviewNotes(e.target.value)}
                    style={{
                      width: '100%',
                      borderRadius: '8px',
                      border: '1px solid #e2e8f0',
                      padding: '10px 12px',
                      fontSize: '14px',
                      fontFamily: 'inherit',
                      resize: 'vertical',
                    }}
                  />
                </div>
              </div>
              <div className='modal-footer-row mt-4'>
                <button className='btn-outline-cancel' onClick={handleCloseInterviewModal}>
                  ยกเลิก
                </button>
                <button
                  className='btn-primary-gradient'
                  onClick={() => {
                    const channelMap = {
                      onsite: 'สัมภาษณ์ที่สถานพยาบาล (On-site)',
                      phone: 'สัมภาษณ์ทางโทรศัพท์',
                      email: 'พูดคุยผ่านทางอีเมล',
                    };
                    const dateFormatted = interviewDate ? interviewDate.format('DD/MM/BBBB') : '';
                    const timeFormatted = interviewTime ? interviewTime.format('HH:mm') : '';
                    const channelLabel = channelMap[interviewChannel] || 'สัมภาษณ์งาน';

                    let constructedNote = `นัดสัมภาษณ์: ${channelLabel}`;
                    if (dateFormatted) constructedNote += ` วันที่ ${dateFormatted}`;
                    if (timeFormatted) constructedNote += ` เวลา ${timeFormatted} น.`;
                    if (interviewNotes.trim()) {
                      constructedNote += `\nรายละเอียดเพิ่มเติม: ${interviewNotes.trim()}`;
                    }

                    handleUpdateApplicantStatus(selectedApplicant.id, 'interview', constructedNote);
                    handleCloseInterviewModal();
                  }}
                >
                  บันทึกสถานะ "รอสัมภาษณ์"
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

export default EmployerJobDashboard;
